import { createAction } from "@reduxjs/toolkit";

export const getBannersSuccess = createAction('banners/getBannersSuccess')
export const getBannersRequest = createAction('banners/getBannersRequest')
export const openPromocodeModal = createAction("modals/openPromocodeModal")